import { VariantsConfig } from './Text.types';
import { Platform } from 'react-native';

export const Variants: VariantsConfig = {
  h1: {
    fontSize: 'text-1600',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-100', // TODO: verify this - with line-height-0 text is not centered vertically
    letterSpacing: 'letter-spacing-0',
  },

  h2: {
    fontSize: 'text-1400',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-025',
    letterSpacing: 'letter-spacing-025',
  },

  h3: {
    fontSize: 'text-1200',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-100', // TODO: when the line-height is set to 'line-height-025' the text is not centered vertically.
    letterSpacing: 'letter-spacing-025',
  },

  h4: {
    fontSize: 'text-800',
    fontFamily: Platform.select({ web: 'Outfit', default: 'DMSerifText' }) as 'Outfit' | 'DMSerifText',
    lineHeight: 'line-height-050',
    letterSpacing: 'letter-spacing-050',
  },

  h5: {
    fontSize: 'text-500',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-050',
    letterSpacing: 'letter-spacing-050',
  },

  h6: {
    fontSize: 'text-300',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-050',
    letterSpacing: 'letter-spacing-0',
  },

  'body-l-semi': {
    fontSize: 'text-400',
    fontFamily: 'Inter-SemiBold',
    lineHeight: 'line-height-100',
    letterSpacing: 'letter-spacing-0',
  },

  'body-l': {
    fontSize: 'text-400',
    fontFamily: 'Inter-Regular',
    lineHeight: 'line-height-100',
    letterSpacing: 'letter-spacing-0',
  },

  'body-m-semi': {
    fontSize: 'text-200',
    fontFamily: 'Inter-SemiBold',
    lineHeight: 'line-height-200',
    letterSpacing: 'letter-spacing-0',
  },

  'body-m': {
    fontSize: 'text-200',
    fontFamily: 'Inter-Regular',
    lineHeight: 'line-height-200',
    letterSpacing: 'letter-spacing-0',
  },

  'body-s-semi': {
    fontSize: 'text-100',
    fontFamily: 'Inter-SemiBold',
    lineHeight: 'line-height-200',
    letterSpacing: 'letter-spacing-0',
  },

  'body-s': {
    fontSize: 'text-100',
    fontFamily: 'Inter-Regular',
    lineHeight: 'line-height-200',
    letterSpacing: 'letter-spacing-0',
  },

  'link-large': {
    fontSize: 'text-400',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-100',
    letterSpacing: 'letter-spacing-0',
    textDecorationLine: 'underline',
  },

  'link-medium': {
    fontSize: 'text-200',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-200',
    letterSpacing: 'letter-spacing-0',
    textDecorationLine: 'underline',
  },

  'link-small': {
    fontSize: 'text-100',
    fontFamily: 'Inter-SemiBold',
    lineHeight: 'line-height-200',
    letterSpacing: 'letter-spacing-0',
    textDecorationLine: 'underline',
  },

  overline: {
    fontSize: 'text-100',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-0',
    letterSpacing: 'letter-spacing-100',
    textTransform: 'uppercase',
  },

  callout: {
    fontSize: 'text-100',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-050', // TODO: when the line-height is set to 'line-height-0' the text is not centered vertically.
    letterSpacing: 'letter-spacing-100',
    textTransform: 'uppercase',
  },

  'callout-large': {
    fontSize: 'text-300',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-0',
    letterSpacing: 'letter-spacing-100',
    textTransform: 'uppercase',
  },

  'caption-semi': {
    fontSize: 'text-050',
    fontFamily: 'Inter-SemiBold',
    lineHeight: 'line-height-100',
    letterSpacing: 'letter-spacing-0',
  },

  caption: {
    fontSize: 'text-050',
    fontFamily: 'Inter-Regular',
    lineHeight: 'line-height-100',
    letterSpacing: 'letter-spacing-0',
  },

  'button-large': {
    fontSize: 'text-200',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-050',
    letterSpacing: 'letter-spacing-0',
  },

  'button-small': {
    fontSize: 'text-100',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-050',
    letterSpacing: 'letter-spacing-0',
  },

  'button-inline': {
    fontSize: 'text-100',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-025',
    letterSpacing: 'letter-spacing-0',
  },

  'input-label': {
    fontSize: 'text-050',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-0',
    letterSpacing: 'letter-spacing-0',
  },

  'input-text': {
    fontSize: 'text-200',
    fontFamily: 'Inter-Regular',
    lineHeight: 'line-height-200',
    letterSpacing: 'letter-spacing-0',
  },

  badge: {
    fontSize: 'text-0',
    fontFamily: 'Inter-Medium',
    lineHeight: 'line-height-0',
    letterSpacing: 'letter-spacing-0',
  },

  'badge-semi': {
    fontSize: 'text-0',
    fontFamily: 'Inter-SemiBold',
    lineHeight: 'line-height-0',
    letterSpacing: 'letter-spacing-0',
  },

  'nav-label': {
    fontSize: 'text-025',
    fontFamily: 'Inter-SemiBold',
    lineHeight: 'line-height-0',
    letterSpacing: 'letter-spacing-0',
  },
  giant: {
    fontSize: 'text-5000',
    fontFamily: 'DMSerifText',
    lineHeight: 'line-height-0', // TODO: verify this - with line-height-0 text is not centered vertically
    letterSpacing: 'letter-spacing-0',
  },
};
